var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"centered":"","background-color":"transparent"}},[_c('v-tab',{attrs:{"to":{ name: 'dashboard' },"exact":""}},[_vm._v("List")]),_c('v-tab',{attrs:{"to":{ name: 'timeline' }}},[_vm._v("Timeline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }